"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Alert", {
  enumerable: true,
  get: function get() {
    return _Alert.default;
  }
});
Object.defineProperty(exports, "InlineAlert", {
  enumerable: true,
  get: function get() {
    return _InlineAlert.default;
  }
});

var _Alert = _interopRequireDefault(require("./src/Alert"));

var _InlineAlert = _interopRequireDefault(require("./src/InlineAlert"));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9hbGVydC9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQUNBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgZGVmYXVsdCBhcyBBbGVydCB9IGZyb20gJy4vc3JjL0FsZXJ0J1xuZXhwb3J0IHsgZGVmYXVsdCBhcyBJbmxpbmVBbGVydCB9IGZyb20gJy4vc3JjL0lubGluZUFsZXJ0J1xuIl19


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/alert/index.js
// module id = 136
// module chunks = 0